import { render, staticRenderFns } from "./viewHandwriting.vue?vue&type=template&id=0c5f9a54&scoped=true&"
import script from "./viewHandwriting.vue?vue&type=script&lang=js&"
export * from "./viewHandwriting.vue?vue&type=script&lang=js&"
import style0 from "./viewHandwriting.vue?vue&type=style&index=0&id=0c5f9a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5f9a54",
  null
  
)

export default component.exports